import React from 'react';
import SalonView from '../Components/SalonView';

export default function AnfitrionPage({ store, onOpenTable }) {
  return (
    <SalonView
      tables={store.tables}
      activeOrders={store.activeOrders}
      orderTotal={store.orderTotal}
      onOpenTable={onOpenTable}
      title="Anfitrión/a"
      subtitle="Control de disponibilidad y ocupación de mesas para recibir clientes."
      showTakeaway={false}
    />
  );
}
